<template>
  <div class="assets__container">
    <Card v-bind="options">
        <div class="filter__bar">
          <div class="items__show__list">
            Show : 
            <Select v-bind="selectConfig" v-model="entries"/>
            <!-- entries -->
            <div class="columns-option">
                <span>Items</span>
               <Select v-bind="columnsOptions" v-model="columnsToShow"/>
               <span v-if="columnsToShow == 'custom'" @click="showFilterCol = !showFilterCol"><i class="fas fa-filter"></i></span>
            </div>
          </div>
          <div class="table__btns">
            <Button v-if="isItemsSelected" v-bind="deleteButton" @click="openCloseAlert('open',null,'multi')" />
            <Button v-bind="addButton" @click="openCloseForm('open')" />
          </div>
        </div>
        <div v-if="columnsToShow == 'custom' && showFilterCol" class="custom-cols-card">
          <Card  v-bind="{...options,padding :{ x : .5, y : .7},}">
            <div class="custom-cols-items">
                <div v-for="(col,index) in config[$route.params.asset].columns" :key="index" class="tab">
                    <CheckBox :text="col.name" :name="col.name" :id="col.key" @input="selectCustomcol(col.key, ...arguments)" :check="!customeColumns[$route.params.asset] ||(customeColumns[$route.params.asset] && customeColumns[$route.params.asset].includes(col.key))"></CheckBox>
                </div>
              </div>
          </Card>
        </div>
        <Table  :config="globalConfig[$route.params.asset]" :data="data" @view="view" v-model="selectedItems" @update="openCloseForm('open',...arguments)" @updateModal="openCloseForm('open',...arguments, -1)" @delete="openCloseAlert('open',...arguments)" @selectMedia="showMedia"/>
    </Card>
    <div v-if="modalIsOpen" class="close__screen"></div>
    <transition name="fade">
        <Card v-if="showAssetForm" v-bind="formCardOptions" class="model">
            <div class="assets__card__container">
              <form ref="form" @submit.prevent="save" :style="loading ? 'overflow-y: hidden;':'overflow-y: auto;'">
                <div class="form__header">
                </div>
                <div  v-for="(item,index) in globalConfig[$route.params.asset].form" :key="index" :class="`group__${item.group}`" :style="`width:${item.width}`">
                      <div class="group__title" v-if="item.title"><span v-if="item.icon" v-html="item.icon"></span><span>{{item.title}}</span></div>
                      <div class="field__container"  v-for="( element, eleIndex ) in item.elements" :key="eleIndex" :style="`width:${element.width}`">
                            <span v-if="element.type == 'group'" class="group__label">{{element.label}}<span class="small"> {{element.subText ? element.subText : ''}}</span></span>
                            <div v-if="element.type == 'group'" class="fields__group" >
                              <div class="field__container"  v-for="( field, fieldIndex ) in element.group_elements" :key="fieldIndex" :style="`width:${field.width}`">
                                  <components :is="field.component" v-bind="field" :error="errors[element.name] ? errors[element.name] :null" :value="form[element.name]? form[element.name][field.name] : undefined"   @input="getGroupe(element.name,field.name,...arguments)" />
                              </div>
                            </div>
                            <template v-else>
                              <components v-if="element.component == 'Select'" :is="element.component" :error="errors[element.name] ? errors[element.name] :null" :selected="form[element.name]" v-bind="{...element,options:selectOptions[element.options_key]}"  v-model="form[element.name]"/>
                              <components v-else :is="element.component" v-bind="element" :borderColor="formIsValid ?  null : element.required && !form[element.name]? 'red' :null"  :error="errors[element.name] ? errors[element.name] :null"  :value="element.key && element.key == 'asset_bundle' && form[element.key] ? form[element.key][element.name]: form[element.name]" @input="getInputValue(element,...arguments)" @remove="remove(element)"/>
                              <Input v-if="form[element.name] == 'other'" hint="Category" :padding="{ x : .7, y : .3}" v-model="otherOption"/>
                            </template>
                      </div>
                </div>
                <div  class="form__actions">
                  <Button v-bind="formButtons.cancel" type="button" @click="openCloseForm('close')"/>
                  <Button v-bind="formButtons.submit"/>
                  <span class="indicatore">(<small>*</small>) Required </span>
                </div>
                <div v-if="loading" class="loading">
                  <span><i class="fas fa-circle-notch"></i></span>
                </div>
              </form>
            </div>
        </Card>
      </transition>
      <!-- edit modal form -->
    <transition name="fade">
        <Card v-if="showModalForm" v-bind="formCardOptions" class="model">
            <div class="assets__card__container">
              <form ref="form" @submit.prevent="save(-1)" :style="loading ? 'overflow-y: hidden;':'overflow-y: auto;'">
                <div class="form__elements">
                  <div class="modal__viewer">
                    <!-- <Viewer v-bind="form" @getMaterial="getModalMaterial" src="https://firebasestorage.googleapis.com/v0/b/nightly-f12d5.appspot.com/o/assetMedia%2Fmodels%2F-MuwHzANpu77TWQU5Gbp%2Foriginal.glb?alt=media&token=6455916d-3307-4a78-97b2-08122497b801"/> -->
                    <WebGlViewer v-if="selectedModalViewer == 'webGl'" :item="form"/>
                    <Viewer v-else-if="selectedModalViewer == 'glb' && form.glb" v-bind="form" :form="form" @getMaterial="getModalMaterial" :src="form.glb.fileURL"/>
                    <ThreeJsViewer v-else :item="form"/>
                  </div>
                    <div class="fields-group">
                      <span class="asset__name">{{selectedAsset ? selectedAsset : null}}</span>
                      <div  v-for="(field,index) in modalConfig[$route.params.asset]" :key="index"  :style="`width:${field.width}`" class="field__container">
                          <components v-if="field.component == 'Select'" :is="field.component"  :selected="form[field.name]" v-bind="{...field,options:selectOptions[field.options_key]}"  v-model="form[field.name]"/>
                          <components v-else :is="field.component" v-bind="field"  :value="form[field.name]" v-model="form[field.name]"/>
                      </div>
                      <div v-if="['character-animation','visual-effect','voice'].includes(this.$route.params.asset)" class="control__btns">
                        <Button v-bind="controlBtns.play" type="button" @click="playAsset"/>
                        <!-- <Button v-bind="controlBtns.pause"/> -->
                      </div>
                    </div>
                </div>
                <div  class="model__form__actions ">
                  <div class="btn__group">
                    <Button v-bind="formButtons.cancel" type="button" @click="openCloseForm('close',-1)"/>
                    <Button v-bind="formButtons.submit"/>
                  </div>
                  <div  class="btn__group">
                    <Button v-bind="formButtons.modal" type="button" :borderColor="selectedModalViewer == 'webGl' ? '#1979E7' : formButtons.modal.borderColor " :borderWidth="selectedModalViewer == 'webGl' ? 2 : null" :disabled=" !form.asset_bundle || form.asset_bundle && !form.asset_bundle.WebGL || form.asset_bundle && form.asset_bundle.WebGL && !form.asset_bundle.WebGL.fileURL" @click="selectType('webGl')">WebGl</Button>
                    <Button v-bind="formButtons.modal" type="button" :borderColor="selectedModalViewer == 'glb' ? '#1979E7' : formButtons.modal.borderColor " :borderWidth="selectedModalViewer == 'glb' ? 2 : null" :disabled=" !form.glb || form.glb && !form.glb.fileURL" @click="selectType('glb')">Glb</Button>
                    <Button v-bind="formButtons.modal" type="button" :borderColor="selectedModalViewer == 'fbx' ? '#1979E7' : formButtons.modal.borderColor " :borderWidth="selectedModalViewer == 'fbx' ? 2 : null" :disabled=" !form.fbx || form.fbx && !form.fbx.fileURL" @click="selectType('fbx')">Fbx</Button>
                  </div>
                  <!-- <span class="indicatore">(<small>*</small>) Required </span> -->

                </div>
                <div v-if="loading" class="loading">
                  <span><i class="fas fa-circle-notch"></i></span>
                </div>
              </form>
            </div>
        </Card>
      </transition>
      <transition name="media_fade">
          <div v-if="showMediaModal" class="media__modal">
            <Media  v-bind="assetMedia"/>
            <span class="close__modal" @click="closeMediaModal"><i class="fas fa-times"></i></span>
            <span class="prev-btn" @click="prevAsset"><i class="fas fa-chevron-left"></i></span>
            <span class="next-btn" @click="nextAsset"><i class="fas fa-chevron-right"></i></span>
          </div>
      </transition>
             <!-- delete popup alert -->
      <transition name="fade">
          <div v-if="openAlert" class="media__modal">
            <div  class="asset__alert">
                <div class="alert__header">
                    <span>Warning</span>
                    <span class="close__alert" @click="openCloseAlert('close')"><i class="fas fa-times"></i></span>
                </div>
                <p>Are you sure you want to delete <span>{{selectedAsset && selectedAsset.name ? selectedAsset.name : `all selected Items ( ${selectedItems.length} )`}}</span> ?</p>
                <div class="alert__action">
                    <Button v-bind="alertAction.cancel"  @click="openCloseAlert('close')"/>
                    <Button v-bind="alertAction.confirm" @click="deleteAsset"/>
                </div>
            </div>

          </div>
      </transition>
      <!-- <Button @click="addAll">Add effects</Button> -->

  </div>
</template>

<script>
  import {uuid} from 'vue-uuid'
  import { db } from "../../firebaseDB";
  import {config, validate,modalConfig, categories} from './config.js'
  import Table from "../../components/global/Table.vue"
  import Card from '../../components/global/Card.vue';
  import Select from '../../components/global/Select.vue';
  import Button from '../../components/global/Button.vue';
  import Input from '../../components/global/Input.vue';
  import Upload from '../../components/global/Upload.vue';
  import RadioBtn from '../../components/global/RadioButton.vue';
  import CheckBox from '../../components/global/CheckBox.vue';
  import Media from '../../components/global/Media.vue';
  import WebGlViewer from '../../components/global/WebGlViewer.vue';
  import ThreeJsViewer from '../../components/global/ThreeJsViewer.vue';
  import Viewer from '../../components/global/viewer.vue';
  import Range from '../../components/global/Range.vue';
  import ColorPicker from '../../components/global/ColorPicker.vue';
  import TexturePicker from '../../components/global/TexturePicker.vue';

  export default {
    components : { Table, Card, Select, Button, Input, Select, Upload, RadioBtn, CheckBox, Media, Viewer, WebGlViewer,Range,ColorPicker, TexturePicker,ThreeJsViewer },
    data(){
      return {
          selectedAsset : null,
          selectedItems : [],
          selectedModalViewer : 'webGl',
          modal_animation : 'Idle',
          modal_environment : 'default',
          otherOption : null,
          currentDbNamed:{
            "3d-model" : "prop",
            "visual-effect" : "effect",
            "character-model" : "character_model",
            "character-animation" : "animation",
            "voice" : "voice",
            "sound" : "sound",
            "video" : "video",
            "images" : "overlay"
          },
          openAlert : false,
          isDeleteConfirmed : false,
          selectedAsset : null,
          loading : false,
          form : {},
          errors:{},
          formIsValid : true,
          selectOptions : {
              sounds : [],
              animations : [],
              materials : [],
              surfaces : [],
              rings : [],
              //modal custmize options
              // modal_animations:['Idle','Jump','Walking','Punch','No', 'Yes'],
              modal_animations:[],
              modal_effects:[],
              modal_voices:[],
              character_models : [],
              environment_image: ['neutral','Default'],
              modal_material : [],
              //assets options
              rotations: ['Inwards', 'Outwards'],
              spectrums: ['Energy', 'Posture'],
              effectType : ['2D','3D'],
              soundType : ['2D','3D'],
              animation_types : ['In Movement','In place'],
              audioType: ['MPEG', 'WAV', 'OGG'],
              videoType : [],
              inverse_kinematics : [],
              // horizontalAlignment: ['left', 'center', 'right'],
              // verticalAlignment: ['top', 'center', 'bottom'],
              verticalAlignment: [
                    {
                      name : "Top",
                      icon : "align_bottom"
                    },
                    {
                      name : "Center",
                      icon : "align_middle"
                    },
                    {
                      name : "Bottom",
                      icon : "align_top"
                    },
              ],
              horizontalAlignment: [
                    {
                      name : "left",
                      icon : "align_right"
                    },
                    {
                      name : "Center",
                      icon : "align_center"
                    },
                    {
                      name : "right",
                      icon : "align_left"
                    },
              ],
              typeOfMedia: ['image', 'video', 'sound'],
              typeOfDisplay: ['Screen', 'Scene'],
              "3d-model-categories" : ["Furniture","Electronics &gadgets","tabletop","nature & plants","books","architecture","cars & bicyles","Food","shapes","Signs","other"],
              "category_types" : [],
              "effects_categories" : ["3D","2D"],
              sound_categories : ["Music","Effects"],
              character_categories : ["Humanoid","animals"],
              character_types : [],
              character_gender : ["M","F","non-binary"],
              rig_types : ["Humanoid","Generic"],
              animation_categories : []

          },
       
          showAssetForm : false,
          showModalForm : false,
          modalIsOpen : false,
          showMediaModal : false,
          selectedMedia : {},
          addButton : {
            name : 'New asset',
            backgroundColor : "#1979E7",
            padding :{ x : 2, y : .7},
            icon : '<i class="fas fa-plus"></i>',
            iconAfter: true

          },
          deleteButton : {
            name : 'Delete',
            // backgroundColor : "#c30b0b",
            padding :{ x : 2, y : .7},
            icon : '<i class="far fa-trash-alt"></i>',
            iconAfter: true

          },
          alertAction : {
              cancel : {
                name : 'Cancel',
                backgroundColor : "#fff",
                color : "#82868b",
                bordered : true,
                borderColor : "#82868b",
                padding :{ x : 1.5, y : .4},
                margin : .5,
              },
              confirm :  {
                name : 'Accept',
                backgroundColor : "#ea5455",
                padding :{ x : 2, y : .5},
                margin : .5
              },
          },
          controlBtns : {
              // pause : {
              //   name : 'pause',
              //   backgroundColor : "#fff",
              //   color : "#82868b",
              //   bordered : true,
              //   borderColor : "#82868b",
              //   padding :{ x : 1.5, y : .4},
              //   margin : .5,
              // },
              play :  {
                name : 'Play',
                backgroundColor : "#ea5455",
                padding :{ x : 2, y : .5},
                margin : .5
              },
          },
          formButtons : {
              cancel : {
                name : 'Cancel',
                backgroundColor : "#fff",
                color : "#82868b",
                bordered : true,
                borderColor : "#82868b",
                padding :{ x : 1.5, y : .4},
                margin : .5,
              },
              submit :  {
                name : 'Save',
                backgroundColor : "#1979E7",
                padding :{ x : 2, y : .5},
                margin : .5
              },
              modal : {
                backgroundColor : "#fff",
                color : "#82868b",
                bordered : true,
                borderColor : "#82868b",
                padding :{ x : 1.5, y : .4},
                margin : .5,
              }
          },
          data : [],
          columnsToShow : "default",
          customeColumns : {},
          showFilterCol : false,
          entries : 20,
          columnsOptions: {
              options : ['default','all', 'custom'],
              selected: "default",
              width: '5rem',
              margin : 0,
              padding : { x:.7, y : .5}
          },
          selectConfig: {
              options : [20,25,50,100],
              selected: 20,
              width: '5rem',
              margin : 0,
              padding : { x:.7, y : .5}
          },
          formCardOptions : {
                padding : { x : 0, y : 0},
                rounded : .3,
                boxShadow : {x : 5, y : 5, blur : 1, color : '#e5e5e526'},
                hasfooter : false,
                hasHeader : false,
                boxShadow : { x : 1, y : 3, blur : 5, color : "#ccc"},         
                bordered : false,
                margin: "0",
                // margin: "3rem 0",
                main : { 
                    padding : { x : 0, y : 0},
                },
                // width : 75,
                // height : 42,
          },
          options :{
                padding : { x : 0, y : 0},
                rounded : .3,
                boxShadow : {x : 5, y : 5, blur : 1, color : '#e5e5e526'},
                hasfooter : false,
                hasHeader : false,
                boxShadow : { x : 1, y : 3, blur : 5, color : "#ccc"},         
                bordered : false,
                // margin: "1.5rem 0",
                main : { 
                    padding : { x : 0, y : 0},
                },
            },
          
      }
    },
    computed : {
      isItemsSelected(){
        return this.selectedItems && this.selectedItems.length > 0 
      },
      globalConfig : {
        get : function (){
          if(this.columnsToShow == "all") return config;
          else if (this.columnsToShow == "default") {
            let conf = JSON.parse(JSON.stringify(config))
            conf[this.$route.params.asset].columns = config[this.$route.params.asset].columns.filter(col => config[this.$route.params.asset].default.includes(col.key));
             return  conf
            }
            else  {
              this.showFilterCol = true;
              if(!this.customeColumns[this.$route.params.asset] || (this.customeColumns[this.$route.params.asset] && !this.customeColumns[this.$route.params.asset].length > 0)){
                this.customeColumns[this.$route.params.asset] = config[this.$route.params.asset].columns.map(col => col.key)
              }
              let conf = JSON.parse(JSON.stringify(config))
              conf[this.$route.params.asset].columns = config[this.$route.params.asset].columns.filter(col => this.customeColumns[this.$route.params.asset].includes(col.key));
              return  conf
  
            }
        },
        set : function(newConf){
          this.columnsToShow  = "default"
          this.$nextTick(() => {
            this.columnsToShow  = "custom"
          })
        },
      },
      config(){return config},
      modalConfig(){return modalConfig},
      assetMedia : {
        get : function() {return this.selectedMedia},
        set : function(newVal) {
            this.selectedMedia  = null
            this.$nextTick(() => {
                this.selectedMedia = JSON.parse(JSON.stringify(newVal))
            // console.log("ne media object",this.selectedMedia);
            })
          },
      }
    },
    watch : {
      '$route.params.asset'(){
        this.data = [];
        this.initialize()
        // this.customeColumns[this.$route.params.asset] = []
      },
      'form.character_category'(value) {
        if(value == 'Humanoid') this.$set(this.selectOptions, 'character_types', ['realistic','robots','cartoons','other'] )  
        else this.$set(this.selectOptions, 'character_types',['birds','fish','primates','other'])
      },
      'form.category'(value) {
         this.$set(this.selectOptions, 'category_types', categories[this.$route.params.asset][value])
         console.log(this.selectOptions);  
      },
      'form.rig'(value) {
        if(value == 'Humanoid') this.$set(this.selectOptions, 'animation_categories', ['In Movement','In place'] )  
        else this.$set(this.selectOptions, 'animation_categories', ['Animal-Like','Bird','primates'])
      },
      selectedModalViewer(value) {
        if(value == 'glb') this.selectOptions.modal_animations = ['Idle','Jump','Walking','Punch','No', 'Yes']
        else this.getAnimations()
      },
      'form.character_model'(){
        this.reformeCurrentForm()
      }
    },
     async mounted () {
        // this.modal_effects = await this.$store.dispatch('getAsset','assets/asset_data/animation')
        this.$store.dispatch('updateCharacters', [])
        this.initialize()
        this.columnsToShow  = "all"
        this.$nextTick(() => {
          this.columnsToShow  = "default"
        })

    },
    methods : {
      // addAll(){this.$store.dispatch('updateEffects')},
      playAsset(){this.$root.$emit('playCurrentAsset', null) },
      reformeCurrentForm(){
        let selectedAsset = this.selectedModalViewer
        if(this.form['character_model'] && this.form['character_model'].id && this.selectOptions['character_models'].length > 0) {
          selectedAsset = this.form['character_model']
          this.form = Object.assign(this.form,this.form['character_model'])
          if(selectedAsset && selectedAsset.asset_bundle && selectedAsset.asset_bundle.WebGL) this.selectedModalViewer = 'webGl'
          else if(selectedAsset && selectedAsset.glb) this.selectedModalViewer = 'glb'
          else this.selectedModalViewer = 'fbx'
          
        }
      },
      selectType(fileType){this.selectedModalViewer = fileType},
      getModalMaterial(material){
        // console.log("material",material);
        this.selectOptions.modal_material = material.map(material => material.name == undefined ? ' Unnamed Material' : material.name)
        // console.log(this.selectOptions.modal_material);
      },
      nextAsset(){
          let element = JSON.parse(JSON.stringify(this.selectedMedia))
          let assetIndex = this.data.findIndex(el => el.id == this.selectedMedia.id);
          element.id = this.data[assetIndex+1] ? this.data[assetIndex+1].id : this.data[this.data.length-1].id;
          if(['webGl','image','glb'].includes(element.type)){
              if(this.data[assetIndex+1]) {
                if(this.data[assetIndex+1].asset_bundle && this.data[assetIndex+1].asset_bundle.WebGL) {
                  element.type = 'webGl'
                  element.items.asset_bundle.WebGL.fileURL = this.data[assetIndex+1].asset_bundle.WebGL.fileURL ;
                  if(this.data[assetIndex+1].asset_bundle.Android && this.data[assetIndex+1].asset_bundle.Android.fileURL)element.items.asset_bundle.Android.fileURL = this.data[assetIndex+1].asset_bundle.Android.fileURL ;
                  if(this.data[assetIndex+1].asset_bundle.iOS && this.data[assetIndex+1].asset_bundle.iOS.fileURL)element.items.asset_bundle.iOS.fileURL = this.data[assetIndex+1].asset_bundle.iOS.fileURL ;
                  element.items.name = this.data[assetIndex+1].name ;
                  element.items.id = this.data[assetIndex+1].id ;

                }else if (this.data[assetIndex+1].glb) {
                  element.type = 'glb'
                    element.item.fileURL = this.data[assetIndex+1].glb.fileURL ;
                }else{
                  element.type = 'image'
                    element.item.imageURL = this.data[assetIndex+1].image.imageURL ;
                }
              }else {
                if(this.data[this.data.length-1].asset_bundle && this.data[this.data.length-1].asset_bundle.WebGL){
                  element.items.name = this.data[assetIndex-1].name ;element.items.id = this.data[assetIndex-1].id ;
                  element.items.asset_bundle.WebGL.fileURL =  this.data[this.data.length-1].asset_bundle.WebGL.fileURL;
                  if(this.data[assetIndex+1].asset_bundle.Android && this.data[assetIndex+1].asset_bundle.Android.fileURL)element.items.asset_bundle.Android.fileURL = this.data[assetIndex+1].asset_bundle.Android.fileURL ;
                  if(this.data[assetIndex+1].asset_bundle.iOS && this.data[assetIndex+1].asset_bundle.iOS.fileURL)element.items.asset_bundle.iOS.fileURL = this.data[assetIndex+1].asset_bundle.iOS.fileURL ;
                  }
                else if (this.data[this.data.length-1].glb) element.item.fileURL = this.data[this.data.length-1].glb.fileURL ;
                else element.item.imageURL = this.data[this.data.length-1].image.imageURL ;
              }
              
            }
          // if(element.type == "glb")  element.item.fileURL = this.data[assetIndex+1] ? this.data[assetIndex+1].glb.fileURL : this.data[this.data.length-1].image.imageURL;
          else if (element.type == "video") {
            element.item.videoName = this.data[assetIndex+1] ? this.data[assetIndex+1].video.videoName : this.data[this.data.length-1].video.videoName;
            element.item.videoURL = this.data[assetIndex+1] ? this.data[assetIndex+1].video.videoURL : this.data[this.data.length-1].video.videoURL;
          }
          this.assetMedia = element
        },
      prevAsset(){
          let element = JSON.parse(JSON.stringify(this.selectedMedia))
          let assetIndex = this.data.findIndex(el => el.id == this.selectedMedia.id);
          element.id = this.data[assetIndex-1] ? this.data[assetIndex-1].id : this.data[0].id;
          if(['webGl','image','glb'].includes(element.type)){
              if(this.data[assetIndex-1]) {
                if(this.data[assetIndex-1].asset_bundle && this.data[assetIndex-1].asset_bundle.WebGL) {
                  element.type = 'webGl'
                  element.items.asset_bundle.WebGL.fileURL = this.data[assetIndex-1].asset_bundle.WebGL.fileURL ;
                  if(this.data[assetIndex-1].asset_bundle.Android && this.data[assetIndex-1].asset_bundle.Android.fileURL)element.items.asset_bundle.Android.fileURL = this.data[assetIndex-1].asset_bundle.Android.fileURL ;
                  if(this.data[assetIndex-1].asset_bundle.iOS && this.data[assetIndex-1].asset_bundle.iOS.fileURL)element.items.asset_bundle.iOS.fileURL = this.data[assetIndex-1].asset_bundle.iOS.fileURL ;
                  element.items.name = this.data[assetIndex-1].name ;
                  element.items.id = this.data[assetIndex-1].id ;

                }else if (this.data[assetIndex-1].glb) {
                  element.type = 'glb'
                    element.item.fileURL = this.data[assetIndex-1].glb.fileURL ;
                }else{
                  element.type = 'image'
                    element.item.imageURL = this.data[assetIndex-1].image.imageURL ;
                }
              }else {
                if(this.data[this.data.length+1].asset_bundle && this.data[this.data.length+1].asset_bundle.WebGL){
                  element.items.name = this.data[assetIndex-1].name ;element.items.id = this.data[assetIndex-1].id ;
                  element.items.asset_bundle.WebGL.fileURL =  this.data[this.data.length+1].asset_bundle.WebGL.fileURL;
                  if(this.data[assetIndex-1].asset_bundle.Android && this.data[assetIndex-1].asset_bundle.Android.fileURL)element.items.asset_bundle.Android.fileURL = this.data[assetIndex-1].asset_bundle.Android.fileURL ;
                  if(this.data[assetIndex-1].asset_bundle.iOS && this.data[assetIndex-1].asset_bundle.iOS.fileURL)element.items.asset_bundle.iOS.fileURL = this.data[assetIndex-1].asset_bundle.iOS.fileURL ;
                  }
                else if (this.data[this.data.length+1].glb) element.item.fileURL = this.data[this.data.length+1].glb.fileURL ;
                else element.item.imageURL = this.data[this.data.length+1].image.imageURL ;
              }
              
            }
          else if (element.type == "video") {
            element.item.videoName = this.data[assetIndex-1] ? this.data[assetIndex-1].video.videoName : this.data[0].video.videoName;
            element.item.videoURL = this.data[assetIndex-1] ? this.data[assetIndex-1].video.videoURL : this.data[0].video.videoURL;
          }
          this.assetMedia = element
        },
      selectCustomcol(key,isChecked){
        if(!this.customeColumns[this.$route.params.asset]) this.customeColumns[this.$route.params.asset] = []
        if(isChecked) this.customeColumns[this.$route.params.asset].push(key)
        else  this.customeColumns[this.$route.params.asset].splice(this.customeColumns[this.$route.params.asset].indexOf(key),1)
        let conf = JSON.parse(JSON.stringify(config))
        conf[this.$route.params.asset].columns = config[this.$route.params.asset].columns.filter(col => this.customeColumns[this.$route.params.asset].includes(col.key));
        this.globalConfig = conf
        this.columnsToShow == "all"
        // console.log(this.customeColumns[this.$route.params.asset]);
      },
      openCloseAlert(action,item, type){
        // if(type && type != 'multi')
        if(item) this.selectedAsset = item;
        if( action =='open')this.openAlert = this.modalIsOpen = true
        else this.openAlert = this.modalIsOpen = false
      },
      confirmDelete(){
        this.openAlert = false;
        isDeleteConfirmed =true;
      },
      showMedia(id,type,key,item) {
        if(item.asset_bundle && item.asset_bundle.WebGL){
          this.selectedMedia.type = 'webGl';
          this.selectedMedia.item = JSON.parse(JSON.stringify(item.asset_bundle.WebGL));
          this.selectedMedia.items = JSON.parse(JSON.stringify(item));
        }
        else if(item.glb) {
          // console.log("item",item);
          this.selectedMedia.type = 'glb';
          this.selectedMedia.item = JSON.parse(JSON.stringify(item['glb']));
        }else {
          this.selectedMedia.type = type;
          this.selectedMedia.item = JSON.parse(JSON.stringify(item[key]));
        }
        this.selectedMedia.id = id;
        this.selectedMedia.isModel = true;
        this.showMediaModal = true
        this.modalIsOpen = true
      },
      closeMediaModal() {
        this.selectedMedia = {}
        this.selectedMedia.isModel = false;
        this.showMediaModal = false
        this.modalIsOpen = false

      },
      async openCloseForm(action,item, val){ 
        this.selectedAsset = item && item.name ? item.name : null
        let selectedAsset = item
        this.formIsValid = true;
        this.form = {};
        this.errors = {};
        if(item && item.id) this.form = {...item}
        // console.log(this.form);
        if(val != -1) {
          this.modalIsOpen = this.showAssetForm = action == 'open';
          const assetIndex = this.$store.state.characters.findIndex(model=>model.name == item.name)
          this.$store.state.characters.splice(assetIndex,1)
        }else{
          if(['character-animation','visual-effect','voice'].includes(this.$route.params.asset)) {
            this.selectOptions['character_models'] = await this.getAsset('character_model')
            if(this.selectOptions['character_models'].length > 0) {
              this.form = {},
              selectedAsset  = this.form =  this.selectOptions['character_models'][0]
              this.form[`${this.currentDbNamed[this.$route.params.asset]}`] = item
              if(this.currentDbNamed[this.$route.params.asset] == 'voice') this.form = Object.assign(this.form,{...this.parseVoice(this.form.voice.description),voiceEffect:this.form.voice.name})
              // console.log("new form", this.form);
              
            }
          }
          this.showModalForm  = this.modalIsOpen = action == 'open';
          if(selectedAsset && selectedAsset.asset_bundle && selectedAsset.asset_bundle.WebGL) this.selectedModalViewer = 'webGl'
          else if(selectedAsset && selectedAsset.glb) this.selectedModalViewer = 'glb'
          else this.selectedModalViewer = 'fbx'
          }
        if(val == -1 || action == 'close') this.showModalForm = action == 'open' ? true : false;
        // console.log( this.showModalForm);
        if(action == 'close') {
          this.initialize()
          this.selectedModalViewer = 'webGl'
        }
        },
        parseVoice(voiceDescription){
            let language =  voiceDescription.split(')')[0] + ')'
            let gender = voiceDescription.split(' ')[voiceDescription.split(' ').length-1]
            return { voiceLanguage: language, voiceGender: gender }
        },
      remove(el) {
        if(el.type && el.type == 'file') {
          delete this.form[el.name] 
        }
      },
      //get form values and reform them same as firebase
      getGroupe(groupName,childName, value){
       if(!this.form[groupName]) this.form[groupName] = {};
       if(groupName == 'allow_sound') this.form[groupName] = value == 'yes'
       else if(groupName == 'rig') this.form[groupName] = value 
       else this.form[groupName][childName] = parseFloat(value);
      },
      getInputValue(element, value){
        if(element.key && element.key == 'asset_bundle') {
          if(!this.form[element.key]) this.form[element.key] = {};
          this.form[element.key][element.name] = value
        }else {
           this.form[element.name] = value
        }
      },
      async save(val){
        // if(this.otherOption) this.form['']
        this.errors = {}
        if(val != -1) {
          const validator = validate(config[this.$route.params.asset].form, this.form)
          this.formIsValid = validator.isValid
          this.errors = validator.errors
            if(this.formIsValid) {
              // console.log('initial form',this.form);
              this.loading=true;
              const res = await this.$store.dispatch('create',{data:this.form,asset_type:this.currentDbNamed[this.$route.params.asset]})
              if(res){
                this.loading = false
                this.openCloseForm('close')
                }
            }
        }else {
          // console.log("modal edit form",this.form);
          this.openCloseForm('close')
        }
        },

    //table actions functions 
      view(){console.log('view')},
      //delete asset confirm before delete
      async deleteAsset(){
        this.openAlert = false;
        this.modalIsOpen = false;
        let res = null
        if(this.selectedAsset) {
           res = await this.$store.dispatch('delete',{item:this.selectedAsset,asset_type:this.currentDbNamed[this.$route.params.asset], type : 'single'})
        }
        else if(this.selectedItems && this.selectedItems.length > 0) {
          res = await this.$store.dispatch('delete',{items:this.selectedItems,asset_type:this.currentDbNamed[this.$route.params.asset], type : 'multi'})

        }
          if(res) this.initialize()
      },
      async getAsset(ref){
        try {
          const res = await db.ref(`assets/asset_data/${ref}`).once('value')
          const reformedRes = Object.keys(res.val()).map(key =>{ return {id:key,  ...res.val()[key]}})
          return reformedRes          
        } catch (error) {
          console.log(error)
        }
      },

      async initialize() {
        this.selectOptions.modal_animations = await this.getAsset('animation')
        this.selectOptions.modal_voices = await this.getAsset('voice')
        this.selectOptions.modal_effects = await this.getAsset('effect')
        let asset = this.globalConfig[this.$route.params.asset]
        if(asset && asset.type) {
          db.ref(`assets/asset_data/${asset.type}/`)
            .once("value")
            .then((snapshot) => {
              let temp = [];
              Object.keys(snapshot.val()).forEach((k) => {
                if (typeof snapshot.val()[k].meta_data !== "undefined") {
                  let row = Object.assign(snapshot.val()[k], {
                    id: k,
                    creator: snapshot.val()[k].meta_data.creator || "unknown",
                    date_uploaded:
                      snapshot.val()[k].meta_data.date_uploaded || "unknown",
                    date_modified:
                      snapshot.val()[k].meta_data.date_modified ||
                      snapshot.val()[k].meta_data.date_uploaded,
                  });
                  // row = this.setupData(row);
                  delete row.meta_data;
                  temp.push(row);
                } else {
                  console.info(`should remove ${asset.type}/${k}`);
                }
              });
              return temp;
            })
            .catch((error) => {
              // console.log("Error - " + error.message);
            })
            .then((snapshot) => {
              // console.log("snapshot",snapshot);
              this.data = snapshot;
            });
        }
      },
    setupData(row) {
      let dimension = "-";
      if (row.hasOwnProperty("dimension")) {
        dimension = row["dimension"].X ? row["dimension"].X : 0;
        dimension += row["dimension"].Y ? ", " + row["dimension"].Y : ", " + 0;
        dimension += row["dimension"].Z ? ", " + row["dimension"].Z : ", " + 0;
        row["dimension_revised"] = dimension;
      }
      if (this.asset_type === "character_model") {
        if (typeof row.fbx === "undefined") {
          row["fbx"] = {
            fileName: "",
            file: "",
            fileURL: "",
          };
        }
      }
      if (typeof row.asset_bundle === "undefined") {
        row["asset_bundle"] = {
          iOS: {
            fileName: "",
            file: "",
            fileURL: "",
          },
          Android: {
            fileName: "",
            file: "",
            fileURL: "",
          },
          WebGL: {
            fileName: "",
            file: "",
            fileURL: "",
          },
        };
      }
      if (
        this.asset_type !== "voice" &&
        typeof row.asset_bundle.WebGL === "undefined"
      ) {
        row["asset_bundle"].WebGL = {
          fileName: "",
          file: "",
          fileURL: "",
        };
      }

      return row;
    },
    }
  }
</script>

<style lang="scss" scoped>
.assets__card__container {
    // max-height: 38rem;
    // overflow-y: auto;
    position: relative;
    height: 100%;
    display: flex;
    // flex-direction: column;
    align-items: center;
    justify-content: center;
}
  ::-webkit-scrollbar {
    width: 5px !important;
    height : 5px;
    background-color: #979797;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1; 
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #bdbdbd; 
    border-radius: .4rem;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
.table__container {
  max-height:70vh !important;
  overflow : auto;
}
.table__btns{
  display : flex;
  align-items : center;
  button:first-child {
    margin : 0 .5rem !important;
  }
}
  .filter__bar {
    display: flex;
    align-items: center;
    justify-content:space-between;
    // background-color: #F2F2F2;
    padding :  1rem;
  }
  .custom-cols-items {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: .3rem;
    // margin : 0 .5rem 0 .5rem;
    background-color: #fdfdfd;
    flex-wrap: wrap;
    width : 100%;
    padding : 1rem;
      div {
        width : 20%;
        padding: .1rem 0;
        white-space : nowrap

      }
  }
  .items__show__list {
    display: flex;
    align-items: center;
    color : #575555;
    font-weight: 300;
    select {
      margin : 0 1rem !important; 
    }
  }
  .close__screen {
    position : absolute;
    top: 0;
    bottom: 0;
    left : 0;
    right: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color : #00000036;
  }
  .model {
    position : absolute;
    // top: 7%;
    top: 0;
    bottom: 0;
    left : 0;
    right: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    background:transparent !important;
    // left : 18%;
  }
  form {
    // padding-top : 5.5rem;
    position: relative;
    display: flex;
    align-items: flex-start;
    // justify-content: space-between;
    flex-wrap: wrap;
    // height: 100%;
    max-height: 35rem;
    width : 75rem;
    // overflow-y: auto;
    background-color: #fff;
    border-radius: .3rem;
    .main__input{ 
      font-size: .9rem !important;
      margin : 0.2rem 0;
      }

  }
  .form__header {
    width : 100%;
    padding : 2.5rem;
    position :sticky;
    top : 0;
    background : #fff;
    z-index: 9;
  }
  .group__title {
    display:flex;
    align-items: center;
    padding : .8rem;
    width : 100%;
    span:first-child {
      font-size: 1.5rem;
      color : #A28DC4;
    }
    span:last-child {
      font-size: 1.3rem;
      padding : 0 .5rem;
    }
  }
   .group__center,  .group__left,  .group__right {
        display: flex;
        flex-wrap: wrap;
        padding : .5rem;
   }
   .group__left {
      position: sticky;
      top: 2rem;
      margin-bottom: 4rem;
   }
  .group__center {
    border-left: 1px solid #E2E6F1;
    border-right: 1px solid #E2E6F1;
  }
  .field__container {
    padding : 0 .5rem;
  }
  .fields__group {
    @extend .group__right;
    padding: .5rem 0;
  }
  .group__label {
    // padding-top : 5rem;
    font-size: 1.2rem;

  }
  .form__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width : 100%;
    position: sticky;
    bottom: 0;
    background-color : #fff;
    box-shadow: 0 0 1px;
    padding: 0.2rem 1rem;
  }
  .model__form__actions {
    @extend .form__actions;
    justify-content:space-between;
    flex-direction: row-reverse;
  }
  .btn__group {
    display: flex;
    align-items: center;
    // justify-content: flex-end;
  }
  .indicatore {
    position: absolute;
    left: 0.7rem;
    font-size: 0.9rem;
    small {
      color : red !important;
    }
  }
  .cube__img {
    position: relative;
    background-color :  #fff;
    width : 11rem;
    height : 11rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    left: 48%;
    top: -28%;
    // top : 6rem;
    z-index: 10;
    span {
      width : 100%;
      text-align: center;
      position: relative;
      top : -1.5rem;
      text-transform: capitalize;
      font-size: 1.3rem;
      color : gray;
      white-space: nowrap;
    }
    img {
      width : 5rem;
      height : 5rem;
    }
  }
  .media__modal {
    position : absolute;
    top : 0;
    bottom : 0;
    left : 0;
    right : 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    // background-color : #0000004d;
  }
  .close__modal {
    position: relative;
    right : -45%;
    top : -45%;
    font-size: 2rem;
    color : #ea5455;
    background-color : #fff;
    border-radius: .4rem;
    box-shadow:  -1px 7px 7px 0px transparent;
    transform: translate(5px,3px);
    padding : .5rem 1rem;
    display : flex;
    align-items: center;
    justify-content: center;
    transition: all .23s ease .1s;
    cursor: pointer;
    z-index: 9999;
    &:hover {
      box-shadow:none;
      transform: translate(0px,0px);
    }
  }
  .next-btn {
    @extend .close__modal;
    top: 0;
    right: -42%;
    color : #1979e7;
  }
  .prev-btn {
    @extend .close__modal;
    top: 0;
    left: -42%;
    color : #1979e7;
  }
  .loading {
    position:absolute;
    top : 0;
    bottom : 0;
    right : 0;
    left : 0;
    background-color:#0000001a;
    z-index: 99;
    display:flex;
    align-items:center;
    justify-content:center;
    span {
      font-size: 3rem;
      color: #374CDA;
      i {
        animation: lds-dual-ring 1.2s linear infinite;
        padding : 1rem;

      }

    }
  }
  .asset__alert {
    height: 14rem;
    width: 31rem;
    background-color: #fff;
    z-index: 999;
    border-radius: .4rem;
    p{
      padding : 2rem;
      color  :#82868b;
      span {
        font-weight: 500;
        color : #ea5455;
      }
    }
  }
  .alert__header {
    padding: .5rem 1rem;
    background-color :#f8f8f8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color : #ea5455;
    font-weight: 400;
    font-size: 1.2rem;
  }
  .close__alert {
    background-color : #fff;
    padding : 0.2rem .7rem;
    box-shadow:  -1px 7px 7px 0px #22292f1a;
    transform: translate(14px, -7px);
    border-radius: 0.357rem;
    cursor: pointer;
    transition: all .23s ease .1s;
    &:hover {
      box-shadow:none;
      transform: translate(18px, -6px);
    }
  }
  .alert__action {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding : .5rem;
  }
  .columns-option {
    display: flex;
    align-items: center;
    padding : .5rem;
    span {
      padding : 0 .5rem;
    }
  }
  .form__elements {
    display: flex;
    justify-content:space-between;
    // padding : 2rem;
    width : 100%;
  }
  .modal__viewer {
    width : 60%;
    height: 29rem;
    position: sticky;
    top: 0;
  }
  .fields-group {
    width : 40%;
    display : flex;
    flex-wrap: wrap;
    align-content: flex-start;
    .field__container{
      padding : .3rem 1rem;
      
    }
  }
  .asset__name {
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.2rem;
    box-shadow: 0px 1px 1px #1979e7;
    padding: 0.5rem;
    border-radius: 0.2rem;
    position: sticky;
    top: 0;
  }
  .control__btns{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
//show animation 
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
  .fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translateY(-800px);
  }
  .fade-enter-active{
    transition: .5s;
  }
  .fade-enter-to {
    opacity: 1;
    transform: translateY(0px);
  }
  .fade-leave {
    opacity: 1;
    transform: translateY(20px);
  }
  .fade-leave-active  {
    transition : .6s;
  }
  .media_fade-enter, .media_fade-leave-to {
    opacity: 0;
    transform: scale(0);
  }
  .media_fade-enter-active{
    transition: .4s;
  }
  .media_fade-enter-to {
    opacity: 1;
    transform: scale(1);
  }
  .media_fade-leave {
    opacity: 1;
    transform: translateY(1.5);
  }
  .media_fade-leave-active  {
    transition : .5s;
  }
</style>


// WEBPACK FOOTER //
// src/views/assets/index.vue